import { computed } from 'vue';
import { useStore } from 'vuex';
import useKillSwitches from '@composables/useKillSwitches';
import useExperimentIds from '@composables/useExperimentIds';
import { deviceTypes } from '@utils/constants';
import useEnvParams from '@composables/useEnvParams';

/**
 * useFeatureEligibility can be use as a central place that combine
 * killswitches, experiments, and together with other flags
 * in order to enable a feature to the end user.
 */

export const ALTERNATE_IMAGE_VIEW_EXP_1 = '2486-21';
export const ALTERNATE_IMAGE_VIEW_EXP_2 = '2544-21';
export const ALTERNATE_IMAGE_VIEW_EXP_3 = '2486-23';

export default function useFeatureEligibility(deviceType) {
  // declarations
  const store = useStore();
  const { experimentIds } = useExperimentIds();
  const { isMcom } = useEnvParams();
  const {
    discoveryGridQuickShopEnabled = false,
  } = useKillSwitches();

  // helpers
  const isDomestic = computed(() => store?.getters?.getPage?.meta?.context?.regionCode === 'US');

  // features
  const isAlternativeImagesViewEnabled = computed(() => (
    ((experimentIds.value.includes(ALTERNATE_IMAGE_VIEW_EXP_1)
    || experimentIds.value.includes(ALTERNATE_IMAGE_VIEW_EXP_3))
      && deviceType === deviceTypes.DESKTOP)
    || (experimentIds.value.includes(ALTERNATE_IMAGE_VIEW_EXP_2)
      && deviceType !== deviceTypes.DESKTOP)
  ));
  const isAlternativeImagesViewExp3Enabled = computed(() => experimentIds.value.includes(ALTERNATE_IMAGE_VIEW_EXP_3)
    && deviceType === deviceTypes.DESKTOP);
  const isDiscoveryGridQuickShopEnabled = computed(() => discoveryGridQuickShopEnabled
    && experimentIds.value.includes('2503-21'));
  const isBuyNowCtaEnabled = computed(() => isDomestic.value && experimentIds.value.includes('2642-21'));
  const isPricingSpecialsBadgeEnabled = computed(() => isMcom && experimentIds.value.includes('2634-21'));

  return {
    isDiscoveryGridQuickShopEnabled,
    isAlternativeImagesViewEnabled,
    isAlternativeImagesViewExp3Enabled,
    isBuyNowCtaEnabled,
    isPricingSpecialsBadgeEnabled,
  };
}
